import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import Dashboard from './components/Dashboard'
import Filters from './components/shared/Filters'
import List from './components/TargetManagement/List'
import RevenueCashFlow from './components/Dashboard/RevenueCashFlow'
import { SalesTargetFilters } from './types'
const BusinessTargets = () => {
    const { t } = useTranslation()
    const currentYear = new Date().getFullYear()

    const { control, watch, setValue } = useForm<SalesTargetFilters>({
        defaultValues: {
            employee_id: [],
            department_ids: [],
            product_group_name: undefined,
            gte: `${currentYear}-01-01`,
            lte: `${currentYear}-12-31`,
        },
    })

    const filters = watch()

    const { TabComponent, TabProps } = useTabs({
        tabs: [
            {
                label: t('dashboard'),
                value: 'dashboard',
                component: <Dashboard filters={filters} />,
            },
            {
                label: t('revenue_cash_flow.title'),
                value: 'cash-flow',
                component: <RevenueCashFlow filters={filters} />,
            },
            {
                label: t('targets_management'),
                value: 'targets',
                component: <List filters={filters} />,
            },
            // {
            //     label: t('performance_details'),
            //     value: 'performance',
            //     component: <PerformanceTable filters={filters} />,
            // },
        ],
    })

    return (
        <div className="space-y-2">
            <SubHeaders
                breadcrumbs={[
                    {
                        title: t('reports'),
                        path: '/reports',
                    },
                    {
                        title: t('targets_management'),
                        path: paths.reportBusinessTargets,
                    },
                ]}
                actions={[]}
            />

            {/* Filters */}
            <Filters control={control} setValue={setValue} />

            {/* Tabs */}
            <div className="space-y-2">
                <Tabs {...TabProps} />
                {TabComponent}
            </div>
        </div>
    )
}

export default BusinessTargets
